export enum ExecutionState {
  Initiated = 'Initiated',
  Running = 'Running',
  Completed = 'Completed',
  Canceled = 'Canceled',
  Failed = 'Failed',
  Timeout = 'Timeout',
}
